import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-269c7e74"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "indicator_wrap" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "indicator_rec" })
], -1))
const _hoisted_2 = { class: "login_container" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = ["innerHTML"]
const _hoisted_5 = { class: "password-dot" }
const _hoisted_6 = {
  key: 1,
  class: "pad-container"
}
const _hoisted_7 = ["onClick"]
const _hoisted_8 = { class: "row" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "0", -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "/assets/icon/Delete@3x.png",
  class: "Delete",
  alt: "backspace"
}, null, -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "row" }, "   ", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ag_img = _resolveComponent("ag-img")!
  const _component_ion_ripple_effect = _resolveComponent("ion-ripple-effect")!
  const _component_ag_alphabet_keypad = _resolveComponent("ag-alphabet-keypad")!
  const _component_ag_box_s = _resolveComponent("ag-box-s")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      (_ctx.checkProcessStatus('simple_login'))
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createElementVNode("div", {
              class: "login_header",
              innerHTML: _ctx.$filters.newLineToBr(_ctx.loginTitle)
            }, null, 8, _hoisted_4),
            _createElementVNode("div", {
              class: _normalizeClass(["login_body", {'login-error':_ctx.wrongPassword}])
            }, _toDisplayString(_ctx.loginMessage), 3),
            _createElementVNode("div", _hoisted_5, [
              (_openBlock(), _createElementBlock(_Fragment, null, _renderList(6, (i) => {
                return _createElementVNode("div", {
                  key: i,
                  class: _normalizeClass(["dot", {fill:(i<=_ctx.reValue.password.length)}])
                }, null, 2)
              }), 64)),
              _createVNode(_component_ag_img, {
                "margin-right": "16px",
                width: "24px",
                height: "24px",
                src: "/assets/icon/plus.png"
              }),
              _createElementVNode("div", {
                class: _normalizeClass(["dot", {fill:(/[A-Z]/).test(_ctx.reValue.password)}])
              }, null, 2)
            ])
          ]))
        : _createCommentVNode("", true),
      (_ctx.reValue.password.length <= 5)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
            (_openBlock(), _createElementBlock(_Fragment, null, _renderList([0,1,2], (row) => {
              return _createElementVNode("div", {
                key: row,
                class: "row"
              }, [
                (_openBlock(), _createElementBlock(_Fragment, null, _renderList(3, (col) => {
                  return _createElementVNode("div", {
                    key: col,
                    class: "ion-activatable ripple-parent letter",
                    onClick: ($event: any) => (_ctx.addNumber(row * 3 + col))
                  }, [
                    _createElementVNode("span", null, _toDisplayString(row * 3 + col), 1),
                    _createVNode(_component_ion_ripple_effect, { type: "unbounded" })
                  ], 8, _hoisted_7)
                }), 64))
              ])
            }), 64)),
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", {
                class: "letter",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.clearNumber('clear')))
              }),
              _createElementVNode("div", {
                class: "ion-activatable ripple-parent letter",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.addNumber(0)))
              }, [
                _hoisted_9,
                _createVNode(_component_ion_ripple_effect, { type: "unbounded" })
              ]),
              _createElementVNode("div", {
                class: "ion-activatable ripple-parent letter",
                onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.clearNumber('del')))
              }, [
                _hoisted_10,
                _createVNode(_component_ion_ripple_effect, { type: "unbounded" })
              ])
            ]),
            _hoisted_11
          ]))
        : _createCommentVNode("", true),
      ((!_ctx.reValue.stepToggle && _ctx.reValue.password.length > 5) || (_ctx.reValue.stepToggle && _ctx.reValue.passwordCheck.length > 5))
        ? (_openBlock(), _createBlock(_component_ag_box_s, {
            key: 2,
            css: {dp: 'flex', direction: 'column', justifyContent: 'flex-end', grow: 1}
          }, {
            default: _withCtx(() => [
              _createVNode(_component_ag_alphabet_keypad, {
                css: {pb: 70, maxHeight: 240, height: '100%'},
                shuffle: false,
                onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.addAlphabet($event))),
                onDelete: _cache[4] || (_cache[4] = ($event: any) => (_ctx.addAlphabet('del')))
              })
            ]),
            _: 1
          }))
        : _createCommentVNode("", true)
    ])
  ], 64))
}